import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Grid2 from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { confirmPasswordReset } from '../../services/UserService';
import { AccountCreationFields, MIN_PASS_LENGTH } from '../enrollment/AccountCreationFields';

export const PasswordReset = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async () => {
    if (password.length < MIN_PASS_LENGTH || repeatPassword !== password || !token) {
      return;
    }

    setSubmitting(true);

    try {
      await confirmPasswordReset(token, password);
      setResult('success');
    } catch {
      setResult('error');
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (!token) {
      navigate('/');
    }
  }, [token, navigate]);

  useEffect(() => {
    if (result === 'success') {
      const timeout = setTimeout(() => {
        navigate('/login');
      }, 5000);
      return () => clearTimeout(timeout);
    }
  }, [result, navigate]);

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 400 }}>
        <Grid2 container spacing={2}>
          <AccountCreationFields
            password={password}
            setPassword={setPassword}
            repeatPassword={repeatPassword}
            setRepeatPassword={setRepeatPassword}
            disabled={result === 'success'}
          />
          <Grid2 size={{ xs: 12 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={
                submitting || !token || password.length < MIN_PASS_LENGTH || password !== repeatPassword || result === 'success'
              }
              fullWidth
            >
              {submitting ? <CircularProgress size={24} /> : 'Zresetuj hasło'}
            </Button>
          </Grid2>
          {result === 'success' && (
            <Grid2 size={{ xs: 12 }}>
              <Typography color="success.main">
                Hasło zostało zmienione. Za chwilę nastąpi przekierowanie do logowania.
              </Typography>
            </Grid2>
          )}
          {result === 'error' && (
            <Grid2 size={{ xs: 12 }}>
              <Typography color="error">Coś poszło nie tak. Spróbuj ponownie później.</Typography>
            </Grid2>
          )}
        </Grid2>
      </Paper>
    </Box>
  );
};
